<template>
  <div>
    <PageHeader :schema="$schemas.creditLetter" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.creditLetter"
        :service="$api.creditLetters"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateCreditLetter',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
